/* eslint-disable camelcase */
/* eslint-disable react/display-name */
/**
 * @file DissentWithoutPsychologyAssessmentView.jsx
 * @author Daniel Aguirre
 * @description DissentWithoutPsychologyAssessment View Page
 */

// Dependencies
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import DashboardCard from 'components/DashboardCard';
import { useHistory } from 'react-router';

import DashboardProgress from 'components/Charts/DashboardProgress';
import styleGuideColors from 'commons/styleGuideColors';

/**
 * DissentWithoutPsychologyAssessment View
 * @param { Object } dashboardStaffActions - DashboardStaff Actions.
 * @return { Node } React node.
 */

function DissentWithoutPsychologyAssessmentView({
  dashboardStaffActions,
  clinicId
}) {
  const { t: translate } = useTranslation();
  const history = useHistory();
  const [chartData, setChartData] = useState([]);

  const { getDissentWithoutPsychologyAssessment } = dashboardStaffActions;

  const getProgressData = (key, color, total) => {
    return {
      label: translate(
        `dashboardStaff.${key.registro_valoracion_psicologia_ultimos6meses}`
      ),
      value: ((key.cantidad * 100) / total).toFixed(3).slice(0, -1),
      color,
      cantidad: key.cantidad,
      valoracionPsicologica: key.registro_valoracion_psicologia_ultimos6meses
    };
  };

  const onGetData = (_, resp) => {
    if (resp?.data && resp?.data?.length !== 0) {
      let data = {};
      let progress = {};
      let max = {};
      let total = 0;
      resp?.data.forEach(({ cantidad }) => {
        total += cantidad;
      });

      resp?.data?.forEach((itm) => {
        if (
          itm.registro_valoracion_psicologia_ultimos6meses ===
          'Registra intervencion'
        ) {
          progress = getProgressData(
            itm,
            styleGuideColors.baxterBrandTeal,
            total
          );
        } else {
          max = getProgressData(itm, styleGuideColors.alertError, total);
        }
      });
      data = {
        progress,
        max
      };
      setChartData(data);
    } else {
      setChartData([]);
    }
  };

  useEffect(() => {
    setChartData(null);
    getDissentWithoutPsychologyAssessment({ clinicId }, onGetData);
  }, [translate, clinicId]);

  const handleDetailClick = (section) => {
    const { cantidad: totalItems, valoracionPsicologica } = chartData[section];
    history.push(
      `/main/dashboard-detail/dissent-psychology-assessment/${valoracionPsicologica}/${totalItems}`
    );
  };

  return (
    <DashboardCard id="F36" loading={!chartData}>
      <DashboardProgress
        title={translate('dashboardStaff.PatientsDissentTitle')}
        description={translate(
          'dashboardStaff.PatientsWithoutPsychologyAssessment'
        )}
        max={chartData?.max}
        progress={chartData?.progress}
        onDetailClick={handleDetailClick}
      />
    </DashboardCard>
  );
}

/**
 * Component definition of proptypes.
 */
DissentWithoutPsychologyAssessmentView.propTypes = {
  dashboardStaffActions: PropTypes.shape({
    getDissentWithoutPsychologyAssessment: PropTypes.func.isRequired
  }),
  clinicId: PropTypes.any
};

export default DissentWithoutPsychologyAssessmentView;
